if (!customElements.get('dm-sessions')) customElements.define('dm-sessions', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = {signal: this.abort.signal};
    const listen = (target, name, handler) => target.addEventListener(name, handler, options);
    const cards = [...this.querySelectorAll('.sa-card')];
    const needs = {"calm": ["demo", "sequences-calm-audio", "sequences-inner-peace-audio", "sequences-pause", "sequences-letting-go", "sequences-deep-relax-audio", "sequences-peacefull-presence-audio", "sequences-peacefull", "sequences-stress-reduction", "sequences-breath-of-life-audio", "sequences-alpha-waves", "sequences-pure-waves-alpha", "sequences-self-love", "balade-nocturne", "sequences-mindfulness", "sequences-mindfulness-long", "sequences-pure-waves-delta", "sleep-stress", "programmes-psychonaute-reduction-du-stress", "sequences-sadhana-audio", "sequences-dream"], "energy": ["sequences-cafeine-audio", "sequences-awakening", "sequences-full-power", "programmes-psychonaute-booster-d-energie", "programmes-psychonaute-s-eveiller", "sequences-good-mood-audio", "sequences-pleasure", "sequences-body-presence", "sequences-pure-waves-beta", "sequences-pure-waves-gamma", "sequences-gamma-training-audio", "sequences-gamma", "sequences-flow", "programmes-psychonaute-le-flow", "programmes-psychonaute-concentration", "breathwork-2", "breathwork-3", "breathwork-4"], "travel": ["demo", "sequences-sadhana-audio", "sequences-3-discovery-audio", "sequences-1-tuto-1-audio", "sequences-appalachia-audio", "sequences-mindful-escape-vendege", "sequences-green-reverie-3-discovery-audio", "balade-nocturne", "sequences-dream", "sequences-daydream-audio", "sequences-destination-theta-audio", "sequences-infinity", "sequences-into-the-mind-audio", "sequences-katmandou-audio", "sequences-quick-delight-2-discovery-ok", "sequences-odyssee-audio", "sequences-psychedelic-journey-audio", "sequences-mind-expansion-psychedelic-journey-2-audio", "sequences-aya-audio", "sequences-the-shaman-s-way-audio", "sequences-theta-2", "sequences-neuro-harmony-bali-sunrise", "sequences-2-tuto-2-audio", "sequences-4-discovery-la-ciotat-audio"], "meditate": ["sequences-mindfulness", "sequences-mindfulness-long", "sequences-breath-of-life-audio", "sequences-peacefull-presence-audio", "sequences-inner-peace-audio", "sequences-silent-retreat-mirapolis", "sequences-katmandou-audio", "sequences-pure-waves-alpha", "sequences-pure-waves-theta", "sequences-pure-waves-theta-long", "sequences-letting-go", "sequences-self-love", "sequences-convergence", "sequences-mantra-audio", "abondance", "sequences-intuitions"], "pause": ["sequences-pause", "sequences-inner-peace-audio", "sequences-quick-delight-2-discovery-ok", "sequences-calm-audio", "sequences-appalachia-audio", "sequences-letting-go", "sequences-self-love", "sequences-deep-relax-audio", "sequences-stress-reduction", "demo", "balade-nocturne", "sequences-3-discovery-audio", "sequences-1-tuto-1-audio", "sequences-2-tuto-2-audio", "sequences-4-discovery-la-ciotat-audio", "sequences-breath-of-life-audio", "sleep-nap"], "sleep": ["sleep-stress", "sleep-drift", "sequences-falling-asleep", "programmes-psychonaute-s-endormir", "sequences-pure-waves-theta", "sequences-pure-waves-theta-long", "sequences-pure-waves-delta", "sleep-nap"]};
    const buttons = [...this.querySelectorAll('[data-need]')];
    const grid = this.querySelector('.sa-grid');
    const tools = this.querySelector('.sa-tools');
    const count = this.querySelector('.sa-result-count');
    const more = this.querySelector('.sa-more');
    let selected = null;
    let limit = 15;
    const filter = () => {
      const family = this.querySelector('[data-family-filter]').value;
      const level = this.querySelector('[data-level-filter]').value;
      const duration = this.querySelector('[data-duration-filter]').value;
      const order = selected && selected !== 'all' ? needs[selected] : null;
      const matching = cards.filter(card => {
        const seconds = Number(card.dataset.seconds || 0);
        const timeMatch = duration === 'all' || (duration === 'short' && seconds > 0 && seconds <= 600) || (duration === 'medium' && seconds > 600 && seconds <= 1800) || (duration === 'long' && seconds > 1800);
        return selected && (!order || order.includes(card.dataset.sessionId)) && timeMatch && (family === 'all' || card.dataset.family === family) && (level === 'all' || card.dataset.level === level);
      });
      if (order) matching.sort((a,b) => order.indexOf(a.dataset.sessionId)-order.indexOf(b.dataset.sessionId));
      const shown = matching.slice(0,selected === 'all' ? matching.length : limit);
      cards.forEach(card => { card.hidden = !shown.includes(card); if(card.hidden)card.open=false; });
      matching.forEach(card => grid.append(card));
      grid.hidden = !selected;
      tools.hidden = !selected;
      count.hidden = !selected;
      this.querySelector('.sa-empty').hidden = !selected || matching.length > 0;
      this.querySelector('[data-count]').textContent = `${shown.length} ${count.dataset.resultLabel}${shown.length < matching.length ? ` ${count.dataset.ofLabel} ${matching.length}` : ''}`;
      more.hidden = !selected || selected === 'all' || shown.length >= matching.length;
    };
    this.querySelector('.sa-needs').hidden = false;
    this.querySelectorAll('.sa-refine select').forEach(select => listen(select,'change',()=>{limit=15;filter();}));
    buttons.forEach(button => listen(button,'click',()=>{
      selected=button.dataset.need;limit=15;
      this.querySelectorAll('.sa-refine select').forEach(select=>select.value='all');
      buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      filter();
    }));
    listen(more,'click',()=>{
      const previous=cards.filter(card=>!card.hidden).length;
      limit+=15;filter();
      if(more.hidden) [...grid.querySelectorAll('.sa-card:not([hidden])')][previous]?.querySelector('summary')?.focus({preventScroll:true});
    });
    cards.forEach(card => listen(card,'toggle',()=>{if(card.open)cards.forEach(other=>{if(other!==card)other.open=false;});}));
    filter();
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const journey = this.querySelector('.sa-journey');
    const landing = this.querySelector('.sa-landing');
    const app = this.querySelector('.sa-app');
    const screen = this.querySelector('.sa-device-screen');
    const rig = this.querySelector('.sa-rig');
    const control = this.querySelector('.sa-motion-control');
    const enter = this.querySelector('.sa-enter');
    let voluntary = false;
    let landed = true;
    let reserved = 0;
    const clamp = value => Math.min(1, Math.max(0, value));
    const range = (value, start, end) => clamp((value - start) / (end - start));
    const smooth = value => value * value * (3 - 2 * value);
    const release = () => {
      if (app.parentElement !== landing) landing.append(app);
      app.inert = false;
      app.style.removeProperty('--ui-scale');
      this.classList.add('sa-landed');
      landed = true;
    };
    const update = () => {
      this.raf = null;
      const reduced = voluntary || preference.matches || document.documentElement.dataset.solarFixed === 'true';
      this.classList.toggle('sa-reduced', reduced);
      this.classList.toggle('sa-motion', !reduced);
      if (reduced) { release(); return; }
      const rect = journey.getBoundingClientRect();
      const available = innerHeight - 72;
      const p = clamp((72 - rect.top) / Math.max(1, rect.height - available));
      const e = smooth(p);
      const mobile = innerWidth < 760;
      const targetWidth = Math.min(innerWidth, 1040);
      const startWidth = mobile ? Math.min(172, innerWidth * .46) : 220;
      // Freeze the screen layout; zoom the entire phone uniformly instead of reflowing it.
      const screenScale = (startWidth - 20) / targetWidth;
      const finalScale = 1 / screenScale;
      const zoom = 1 + (finalScale - 1) * e;
      const startLeft = mobile ? (innerWidth - startWidth) / 2 : innerWidth * .65;
      const finalLeft = (innerWidth - targetWidth) / 2 - 10 * finalScale;
      const startTop = available * (mobile ? .47 : .17);
      const left = startLeft + (finalLeft - startLeft) * e;
      const top = startTop + (-10 * finalScale - startTop) * e;
      this.style.setProperty('--device-width', `${startWidth}px`);
      this.style.setProperty('--device-height', `${startWidth * 2.065}px`);
      this.style.setProperty('--device-scale', String(zoom));
      this.style.setProperty('--atlas-width', `${targetWidth}px`);
      this.style.setProperty('--screen-scale', String(screenScale));
      this.style.setProperty('--frame-opacity', String(1 - smooth(range(p,.8,1))));
      this.style.setProperty('--device-left', `${left}px`);
      this.style.setProperty('--device-top', `${top}px`);
      this.style.setProperty('--device-angle', `${(mobile ? -3 : -7) * (1 - smooth(range(p,0,.7)))}deg`);
      this.style.setProperty('--hand-opacity', String(1 - smooth(range(p,.22,.72))));
      this.style.setProperty('--intro-opacity', String(1 - smooth(range(p,.02,.36))));
      this.style.setProperty('--intro-y', `${-range(p,0,.36) * 24}px`);
      this.style.setProperty('--scene-opacity', String(1 - smooth(range(p,.55,.97))));
      this.style.setProperty('--scene-scale', String(1 + .2 * e));
      this.style.setProperty('--control-opacity', String(1 - range(p,.78,.96)));
      this.classList.remove('sa-mini');
      this.classList.toggle('sa-arriving', p > .8);
      if (p >= .999) release();
      else {
        if (landed) {
          reserved = Math.max(app.offsetHeight, available);
          this.style.setProperty('--landing-height', `${reserved}px`);
          screen.append(app);
          landed = false;
        }
        this.classList.remove('sa-landed');
        app.inert = true;
        app.style.removeProperty('--ui-scale');
      }
    };
    const schedule = () => { if (!this.raf) this.raf = requestAnimationFrame(update); };
    control.hidden = false;
    listen(control, 'click', () => { voluntary = true; release(); schedule(); app.scrollIntoView({block:'start',behavior:'instant'}); });
    listen(enter, 'click', event => { event.preventDefault(); const y=landing.getBoundingClientRect().top+scrollY-72; window.scrollTo({top:y+2,behavior:preference.matches?'instant':'smooth'}); });
    listen(window, 'scroll', schedule);
    listen(window, 'resize', schedule);
    listen(preference, 'change', schedule);
    this.observer = new MutationObserver(schedule);
    this.observer.observe(document.documentElement, {attributes:true, attributeFilter:['data-solar-fixed']});
    schedule();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.raf);
  }
});
